import { NgModule } from '@angular/core'; 
import { registerLocaleData } from '@angular/common';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import {
  AngularFireFunctionsModule,
  REGION,
} from '@angular/fire/compat/functions';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageComponent } from './core/components/login-page/login-page.component';
import { LoginCardComponent } from './core/components/login-page/login-card/login-card.component';
import { MainComponent } from './core/components/main/main.component';
import { SharedModule } from './shared/shared.module'; 
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import { NZ_I18N, en_US, ja_JP } from 'ng-zorro-antd/i18n';

import ja from '@angular/common/locales/ja';

import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { HeaderComponent } from './core/components/main/header/header.component';
import { FooterComponent } from './core/components/main/footer/footer.component';
import { SidebarComponent } from './core/components/main/sidebar/sidebar.component'; 
import { DragDropModule } from '@angular/cdk/drag-drop';

import { CoreModule } from './core/core.module';
import { SaleRacketsComponent } from './features/kurashima/components/sale-rackets/sale-rackets.component';

registerLocaleData(ja);

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key])

@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    LoginCardComponent,
    MainComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    SaleRacketsComponent
  ],
  imports: [
    CoreModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    // Realtime Database: trạng thái sống của game đua vịt.
    AngularFireDatabaseModule,
    // Cloud Functions: các thao tác cần Admin SDK (tạo tài khoản đăng nhập).
    AngularFireFunctionsModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSidenavModule,
    SharedModule,
    DragDropModule
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    { provide: NZ_ICONS, useValue: icons },
    // Phải khớp `region` khai báo trong functions/src/index.ts, nếu không
    // client sẽ gọi sang region khác và nhận lỗi "not-found".
    { provide: REGION, useValue: 'us-central1' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
